import PropTypes from 'prop-types';
import { createRef, useState } from 'react';
import { Button } from '@ui-propulsion/react-components';
import parse from 'html-react-parser';
import styles from './prequal.module.scss';
import CurrencyInput from '../../currencyInput/currencyInput';
import Dropdown from '../../dropdown/dropdown';
import * as defaults from '../constants';
import Tooltip from '../../toolTip/toolTip';
import { getNumberFromString } from '../../currencyInput/helpers';

function Prequal({
  title = defaults.title,
  url = defaults.url,
  inputPlaceholder = defaults.inputPlaceholder,
  loanPurposes = defaults.personalLoans,
  tooltip = defaults.tooltip,
  ctaLabel = defaults.ctaLabel,
  defaultMaxAmount = 40000,
}) {
  const input = createRef();
  const dropdown = createRef();
  const [hasCurrencyError, setHasCurrencyError] = useState('');
  const [hasDropdownError, setHasDropdownError] = useState('');

  const handleSubmit = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const queryParam = searchParams.toString();

    let hasError = false;
    const loanAmount = getNumberFromString(input.current.value);
    const loanPurpose = dropdown.current.value;
    const loanUrl = loanPurposes.find((item) => item.value === loanPurpose);
    const redUrl = loanUrl?.url ?? url;
    if (
      loanAmount === '' ||
      loanAmount > defaultMaxAmount ||
      loanAmount < 1000
    ) {
      setHasCurrencyError(
        `Enter $1,000 to $${defaultMaxAmount.toLocaleString()}`
      );
      hasError = true;
    } else {
      setHasCurrencyError('');
    }
    if (loanPurpose === '') {
      setHasDropdownError('Select a loan purpose');
      hasError = true;
    } else {
      setHasDropdownError('');
    }
    if (!hasError) {
      const paramString = queryParam ? `&${queryParam}` : '';
      window.location.assign(
        `${redUrl}?loanAmount=${loanAmount}&loanPurpose=${loanPurpose}${paramString}`
      );
    }
  };
  const tooltipStyle = { right: 0, left: 'auto', top: '100%' };
  return (
    <div className={styles.wrapper}>
      {title ? <p className={styles.title}>{title}</p> : null}
      <CurrencyInput
        ref={input}
        hasError={hasCurrencyError}
        placeholder={inputPlaceholder}
      />
      <Dropdown
        ref={dropdown}
        options={loanPurposes}
        errorMessage={hasDropdownError}
        className={
          hasDropdownError
            ? `${styles.dropdownError} ${styles.dropdown}`
            : styles.dropdown
        }
        elevation
      />
      <Button
        type="submit"
        color="red"
        variant="primary"
        fullWidth
        data-testid="check-rate"
        className={styles.submitBtn}
        aria-label="submit-rate"
        onClick={handleSubmit}
      >
        {ctaLabel}
      </Button>
      <div className={styles.footer}>
        {tooltip?.note && (
          <span className={styles.tooltipNote}>{parse(tooltip.note)}</span>
        )}
        {tooltip?.helpNote && (
          <Tooltip message={tooltip.helpNote} style={tooltipStyle} />
        )}
      </div>
    </div>
  );
}

Prequal.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  inputPlaceholder: PropTypes.string,
  loanPurposes: PropTypes.arrayOf(PropTypes.object),
  tooltip: PropTypes.shape({
    note: PropTypes.string,
    helpNote: PropTypes.string,
  }),
  ctaLabel: PropTypes.string,
};

export default Prequal;
